/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
    SourceToJSONTyped,
} from './Source';

/**
 * 
 * @export
 * @interface PaginatedSourceList
 */
export interface PaginatedSourceList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSourceList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSourceList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSourceList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Source>}
     * @memberof PaginatedSourceList
     */
    results: Array<Source>;
}

/**
 * Check if a given object implements the PaginatedSourceList interface.
 */
export function instanceOfPaginatedSourceList(value: object): value is PaginatedSourceList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedSourceListFromJSON(json: any): PaginatedSourceList {
    return PaginatedSourceListFromJSONTyped(json, false);
}

export function PaginatedSourceListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSourceList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(SourceFromJSON)),
    };
}

  export function PaginatedSourceListToJSON(json: any): PaginatedSourceList {
      return PaginatedSourceListToJSONTyped(json, false);
  }

  export function PaginatedSourceListToJSONTyped(value?: PaginatedSourceList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(SourceToJSON)),
    };
}

